module.exports = __webpack_public_path__ + "img/4894502.jpg";